var latestId = 1;
export var getNextId = function () { return ++latestId; };
export var resetIdGenerator = function (shapes) {
    latestId = (shapes === null || shapes === void 0 ? void 0 : shapes.length) ? Math.max.apply(Math, shapes.map(function (_a) {
        var id = _a.id;
        return id;
    })) : 1;
};
//# sourceMappingURL=id-generator.js.map